import NextProgress from 'next-progress';
import React from 'react';

import { BRAND } from '@/lib/const';
import { useAlertBanner } from '@/providers/AlertBannerProvider/AlertBannerContext';
import { theme } from '@/theme/getTheme';

export const NextProgressWrapper = () => {
  const { cookieAlertBanner } = useAlertBanner();

  const color = cookieAlertBanner
    ? BRAND === 'gallet'
      ? theme.colors.primaryLight
      : theme.colors.primaryDark
    : theme.colors.white;

  return (
    <NextProgress
      key={cookieAlertBanner ? 'primaryDark' : 'white'}
      color={color}
      data-testid='progressbar'
      height={4}
      options={{ showSpinner: false }}
    />
  );
};
